import { apiSlice } from './apiSlice';
const USERS_URL = '/api/auth';

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/login`,
        method: 'POST',
        body: data,
      }),
    }),

    register: builder.mutation({
      query: ({ data, hasImage }) => ({
        url: `${USERS_URL}/register?hasImage=${hasImage}`,
        method: 'POST',
        body: data,
      }),
     }),

  }),
});

export const { useLoginMutation , useRegisterMutation } = userApiSlice;
